export const Internship = () => {
  return (
    <section className="py-14 text-center">
      <h2 className="text-4xl font-bold mb-6">Internship Program</h2>

      <p className="text-xl font-semibold text-blue-600 mb-4">
        Learn → Work → Earn → Get Hired
      </p>

      <p className="text-gray-600 max-w-3xl mx-auto mb-10">
        Our internship program gives you real industry experience by working on live projects.
        You will collaborate with developers, solve real problems, and build production-level applications.
      </p>

      <div className="flex justify-center gap-8 flex-wrap mb-10">
        <span>✔ 3 / 6 Months Duration</span>
        <span>✔ Real-Time Projects</span>
        <span>✔ Stipend Based Performance</span>
        <span>✔ Job Opportunity</span>
      </div>

      <button className="px-8 py-3 bg-blue-600 text-white rounded-xl">
        Apply for Internship
      </button>
    </section>
  );
};